<template>
  <section  v-if="variant === variants.v1" class="n-section-primary tw-relative" :style="`background-color: var(--c-${vars.backgroundColor}) `">
    <div class="tw-pb-8 tw-text-center">
      <h3 v-if="vars.titleText" class="tw-pb-6" style="color: var(--c-text-primary)">
        {{ vars.titleText }}
      </h3>
      <div v-else-if="vars.titleHtml" v-html="vars.titleHtml" class="tw-pb-6"></div>
      <nuxt-link
        v-if="variant === variants.v1"
        :to="ROUTES.BLOGS"
        :external="true"
        :class="`n-${vars.buttonTypeText} !tw-pb-4`"
      >
        {{ vars.buttonLabelText }}
      </nuxt-link>
    </div>
    <div v-if="isBlogsLoading">
      <loader loader-color="var(--c-primary)" />
    </div>
    <div class="tw-relative tw-w-full tw-max-w-[450px] tw-px-6 md:tw-max-w-none md:tw-px-4 lg:tw-px-0">
      <Swiper
        :modules="[SwiperPagination]"
        :slides-per-view="3"
        :space-between="30"
        :loop="true"
        effect="fade"
        :clickable="true"
        :breakpoints="{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          1336: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        }"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        class="tw-w-full"
      >
        <SwiperSlide
          v-for="(blog, index) in blogs"
          :key="`blog-${index}`"
          class="tw-flex tw-items-center tw-justify-center"
          style="border-radius: var(--rounded)"
          :delay="index * 250"
        >
          <Theme4BlogsBlogCard :blog="blog" :index="index" version="v1"/>
        </SwiperSlide>
      </Swiper>
      <LibrarySliderPagination
        :swiper="swiper"
        variant="v3"
        :can-paginate-back="canPaginateBack"
        :can-paginate-next="canPaginateNext"
      />
    </div>
    <nuxt-link
      v-if="variant === variants.v2 && vars.buttonLabelText"
      :to="ROUTES.BLOGS"
      :external="true"
      :class="`n-${vars.buttonTypeText} tw-mt-6 md:tw-mt-10`"
      >{{ vars.buttonLabelText }}</nuxt-link
    >
  </section>

   <section  v-if="variant === variants.v2" class="n-section-primary tw-relative" :style="`background-color: var(--c-${vars.backgroundColor}) `">
    <div class="tw-pb-8 tw-text-center">
      <h3 v-if="vars.titleText" class="tw-pb-6" style="color: var(--c-text-primary)">
        {{ vars.titleText }}
      </h3>
      <div v-else-if="vars.titleHtml" v-html="vars.titleHtml" class="tw-pb-6"></div>
      <nuxt-link
        v-if="variant === variants.v1"
        :to="ROUTES.BLOGS"
        :external="true"
        :class="`n-${vars.buttonTypeText} !tw-pb-4`"
      >
        {{ vars.buttonLabelText }}
      </nuxt-link>
    </div>
    <div v-if="isBlogsLoading">
      <loader loader-color="var(--c-primary)" />
    </div>
    <div class="tw-relative tw-w-full tw-max-w-[450px] tw-px-6 md:tw-max-w-none md:tw-px-4 lg:tw-px-0">
      <Swiper
        :modules="[SwiperPagination]"
        :slides-per-view="3"
        :space-between="30"
        :loop="true"
        effect="fade"
        :clickable="true"
        :breakpoints="{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          1336: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        }"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        class="tw-w-full"
      >
        <SwiperSlide
          v-for="(blog, index) in blogs"
          :key="`blog-${index}`"
          class="tw-flex tw-items-center tw-justify-center"
          style="border-radius: var(--rounded)"
          :delay="index * 250"
        >
          <Theme4BlogsBlogCard :blog="blog" :index="index" version="v2"/>
        </SwiperSlide>
      </Swiper>
      <LibrarySliderPagination
        :swiper="swiper"
        variant="v13"
        :can-paginate-back="canPaginateBack"
        :can-paginate-next="canPaginateNext"
      />
    </div>
    <nuxt-link
      v-if="variant === variants.v2 && vars.buttonLabelText"
      :to="ROUTES.BLOGS"
      :external="true"
      :class="`n-${vars.buttonTypeText} tw-mt-6 md:tw-mt-10`"
      >{{ vars.buttonLabelText }}</nuxt-link
    >
  </section>

  <section  v-if="variant === variants.v3" class="n-section-primary tw-relative" :style="`background-color: var(--c-${vars.backgroundColor}) `">
    <div class="tw-pb-8 tw-text-center">
      <h3 v-if="vars.titleText" class="tw-pb-6" style="color: var(--c-text-primary)">
        {{ vars.titleText }}
      </h3>
      <div v-else-if="vars.titleHtml" v-html="vars.titleHtml" class="tw-pb-6"></div>
      <nuxt-link
        v-if="variant === variants.v1"
        :to="ROUTES.BLOGS"
        :external="true"
        :class="`n-${vars.buttonTypeText} !tw-pb-4`"
      >
        {{ vars.buttonLabelText }}
      </nuxt-link>
    </div>
    <div v-if="isBlogsLoading">
      <loader loader-color="var(--c-primary)" />
    </div>
    <div class="tw-relative tw-w-full tw-max-w-[450px] tw-px-6 md:tw-max-w-none md:tw-px-4 lg:tw-px-0">
      <Swiper
        :modules="[SwiperPagination]"
        :slides-per-view="3"
        :space-between="30"
        :loop="true"
        effect="fade"
        :clickable="true"
        :breakpoints="{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          1336: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        }"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        class="tw-w-full"
      >
        <SwiperSlide
          v-for="(blog, index) in blogs"
          :key="`blog-${index}`"
          class="tw-flex tw-items-center tw-justify-center"
          style="border-radius: var(--rounded)"
          :delay="index * 250"
        >
          <Theme4BlogsBlogCard :blog="blog" :index="index" version="v3"/>
        </SwiperSlide>
      </Swiper>
      <LibrarySliderPagination
        :swiper="swiper"
        variant="v13"
        :can-paginate-back="canPaginateBack"
        :can-paginate-next="canPaginateNext"
      />
    </div>
    <nuxt-link
      v-if="variant === variants.v2 && vars.buttonLabelText"
      :to="ROUTES.BLOGS"
      :external="true"
      :class="`n-${vars.buttonTypeText} tw-mt-6 md:tw-mt-10`"
      >{{ vars.buttonLabelText }}</nuxt-link
    >
  </section>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { useWebsiteStore } from '~/units/website/store';
import type { Component } from '~/types';
import Loader from '~/components/common/Loader.vue';
import NotFound from '~/components/theme2/base/NotFound.vue';
import indexGlobal from '~/mixins/index.global';
import { BlogsMixin } from '~/units/blogs/mixins/blogs.mixin';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useBlogsStore } from '~/units/blogs/store';
import SearchBox from '~/components/common/SearchBox.vue';
import { ROUTES } from '~/constants/ui.constants';

export default defineNuxtComponent({
  name: 'Theme4BlogsBox',
  components: { SearchBox, NotFound, Loader },

  mixins: [BlogsMixin, indexGlobal, ComponentMixin],

  async setup(props: { component: Component }) {
    const blogsStore = useBlogsStore();
    await blogsStore.fetchBlogsInPage(props.component);
  },

  data() {
    return {
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
    };
  },

  mounted() {
    this.onSlideChange();
  },

  computed: {
    ...mapState(useWebsiteStore, ['sidebarComponents']),

    ROUTES() {
      return ROUTES;
    },

    ctaText() {
      return this.vars.ctaText || 'View All Blogs';
    },

    buttonType() {
      return this.vars.buttonTypeText || 'primary';
    },

    backgroundColor() {
      return this.vars.backgroundColor || 'section_primary';
    },

    isLatestCarouselEnabled() {
      return this.vars.isLatestCarouselEnabledNumber;
    },

    isLatestCarouselVisible() {
      const route = useRoute();
      return this.isLatestCarouselEnabled && this.blogs.length !== 0 && !route.query.q && !route.query.page;
    },

    titleHtml() {
      return this.vars.titleHtml;
    },
  },

  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
  },
});
</script>
